import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'zui-inline-empty-state',
  standalone: true,
  imports: [ CommonModule, MatIconModule ],
  templateUrl: './inline-empty-state.component.html',
  styleUrl: './inline-empty-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InlineEmptyStateComponent {
  icon = input<string>('info_outline');
  message = input<string>('No items configured');
}
